export default "__VITE_ASSET__DK2g30O9__"